import { c as _c } from "react/compiler-runtime";
import Svg, { type SvgProps } from '../../Svg';
const RollForwardIcon = props => {
  const $ = _c(3);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <path d="M5.625 0.75L7.125 2.25L5.625 3.75M7.125 2.25H6C4.80653 2.25 3.66193 2.72411 2.81802 3.56802C1.97411 4.41193 1.5 5.55653 1.5 6.75C1.5 7.94347 1.97411 9.08807 2.81802 9.93198C3.66193 10.7759 4.80653 11.25 6 11.25C6.125 11.25 6.2515 11.2445 6.375 11.2345M10.4845 6.375C10.4945 6.4985 10.5 6.625 10.5 6.75C10.5004 7.1295 10.4527 7.50751 10.358 7.875M9.447 3.8575C9.69134 4.14788 9.89782 4.46811 10.0615 4.8105M9.436 9.656C9.356 9.75067 9.27133 9.84267 9.182 9.932C8.91391 10.2006 8.61284 10.4341 8.286 10.627" className="stroke-current" strokeLinecap="round" strokeLinejoin="round" />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== props) {
    t1 = <Svg width={12} height={12} {...props}>{t0}</Svg>;
    $[1] = props;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
};
export default RollForwardIcon;